import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Integrations from "../../../integration/Integrations.jsx";
import { INTEGRATION_KEY } from "../../../state/integration/Constants";
import { BILLING_TYPE } from '../../../state/invoice/InvoiceBillingType';

class InvoiceExportedToLightspeedRetailEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            invoice: this.props.invoice || null,
            proposal: this.props.proposal || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            invoice: nextProps.invoice || null,
            proposal: nextProps.proposal || null,
        })
    }

    renderMessage() {
        if (this.state.object.type === "late-fee-external-links") {
            switch (this.state.object.attributes.status) {
                case "exported": return <FormattedMessage
                    id="invoice.analytics.events.exported.ls_retail.late_fee_adjustment_notes"
                    defaultMessage="A late fee has been applied to invoice {identifier}"
                    values={{
                        identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                    }}
                />
            }
        }

        switch (this.state.object.attributes.entityType) {
            case 'main':
                return !this.isReturn() ?
                    <FormattedMessage
                        id="invoice.analytics.events.exported.ls_retail.text"
                        defaultMessage="Invoice {identifier} has been exported to {integrationKey} as a completed sale"
                        values={{
                            integrationKey: Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.LIGHTSPEED_RETAIL),
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                        }}
                    /> : <FormattedMessage
                        id="invoice.analytics.events.return_exported.ls_retail.text"
                        defaultMessage="Return {identifier} has been exported to {integrationKey} as a completed sale"
                        values={{
                            integrationKey: Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.LIGHTSPEED_RETAIL),
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                        }}
                    />
            case 'void':
                return <FormattedMessage
                    id="invoice.analytics.events.exported.ls_retail.void_text"
                    defaultMessage="Invoice {identifier} has been refunded in {integrationKey}"
                    values={{
                        integrationKey: Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.LIGHTSPEED_RETAIL),
                        identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                    }}
                />
            case 'invoice-adjustment':
            case 'payment-adjustment':
                return <span>
                    <FormattedMessage
                        id="invoice.analytics.events.exported.ls_retail.adjustment_text"
                        defaultMessage="An adjustment for {identifier} has been made in {integrationKey}"
                        values={{
                            integrationKey: Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.LIGHTSPEED_RETAIL),
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                        }}
                    />
                    {this.state.object.attributes.metadata && this.state.object.attributes.metadata.notes ?
                        <span className={'ml-1'}>
                            <span className={'mr-1'}>/</span>
                            <FormattedMessage
                                id="invoice.analytics.events.exported.ls_retail.invoice_adjustment_notes"
                                defaultMessage="Reason: {notes}"
                                values={{
                                    notes: this.state.object.attributes.metadata.notes,
                                }}
                            />
                        </span> : ''}
                </span>
            case 'late-fee-adjustment':
                return <FormattedMessage
                    id="invoice.analytics.events.exported.ls_retail.late_fee_adjustment_notes"
                    defaultMessage="A late fee has been applied to invoice {identifier}"
                    values={{
                        identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                    }}
                />
            case 'negative-late-fee-adjustment':
                return <FormattedMessage
                    id="invoice.analytics.events.exported.ls_retail_late_fee_adjustments_undone_notes"
                    defaultMessage="A late fee has been undone to invoice {identifier}"
                    values={{
                        identifier: <strong>{this.state.invoice.attributes.identifier}</strong>
                    }}
                />
        }
        return ''
    }

    isReturn() {
        return this.state.invoice && this.state.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }


    render() {
        let lightspeedUrl = Integrations.getPaymentTransactionExternalUrl(this.state.object)
        return <div className={"row " + this.state.className}>
            <div className={'col-12'}>
                <p className={'mb-2'}>
                    {this.renderMessage()}
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-3'}>
                    <a href={lightspeedUrl} target="_blank">
                        <img src="/images/lightspeed_retail_logo.png" width="150px" />
                    </a>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <a href={lightspeedUrl} target={'_blank'} className={'btn btn-sm btn-outline-primary'}>
                            <FormattedMessage
                                id="invoice.analytics.events.exported.ls_retail.open"
                                defaultMessage="Open sale in lightspeed"
                            />
                        </a>
                    </p>
                </div>
            </div>
        </div>
    }

}

export default InvoiceExportedToLightspeedRetailEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-ls-retail.component.jsx